module.exports = __webpack_public_path__ + "img/default-lighthouse.7b3cf8f5.svg";